import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpResponse } from "@angular/common/http";
import { CourseManagementService } from "../course-management.service";
import Swal from "sweetalert2";
// import Swal from "sweetalert2";
@Component({
  selector: 'app-add-course',
  templateUrl: './add-course.component.html',
  styleUrls: ['./add-course.component.scss']
})
export class AddCourseComponent implements OnInit {

  selectedFile: File;
  uploadCourseImage: any;

  courseForm: FormGroup;
  formSubmitted: boolean = false;
  ImageUpload: boolean = false;
  showImageError: boolean = true;
  courseRequest = {
    title: null,
    imageUrl: null,
    sortOrder: null,
    description: null
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private CourseManagementService: CourseManagementService
  ) { }

  ngOnInit() {
    this.initialiseForms();
  }


  initialiseForms() {
    this.courseForm = this.fb.group({
      title: ["", [Validators.required]],
      sortOrder: ["", [Validators.required]],
      description: ["", [Validators.required]],

    });
  }



  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    this.uploadCourseImage = this.selectedFile.name;
    this.spinner.show();
    this.CourseManagementService.uploadImage(this.selectedFile).subscribe(data => {
      if (data["message"] === "Success") {
        Swal.fire("Success", "Image uploaded successfully!", "success");
        this.courseRequest.imageUrl = data.data.fileUrl;
        this.uploadCourseImage = data.data.fileUrl;
        this.showImageError = false;
        this.ImageUpload = true;
        this.spinner.hide();
      } else {
        this.spinner.show();
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    });
  }

  addCourse() {
    this.formSubmitted = true;
    if (this.courseForm.valid) {
      this.courseRequest.title = this.courseForm.value.title;
      this.courseRequest.sortOrder = this.courseForm.value.sortOrder;
      this.courseRequest.imageUrl = this.uploadCourseImage;
      this.courseRequest.description = this.courseForm.value.description;
      this.CourseManagementService.saveCourse(this.courseRequest).subscribe(data => {
        if (data["message"] === "Success") {
          Swal.fire("Success", "Course Added successfully!", "success");
          this.router.navigate(["/main/course-management/view-course"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }

  }

  cancel() {
    this.router.navigate(["/main/course-management/view-course"]);
  }
}

